<template>
  <path
    d="M13.273 24.824c6.778 0 12.272-5.334 12.272-11.912C25.545 6.333 20.051 1 13.273 1 6.495 1 1 6.333 1 12.912c0 6.578 5.495 11.912 12.273 11.912Zm17.272 5.735L22 22.5"
    stroke="currentColor"
    fill="none"
    fill-rule="evenodd"
    stroke-linecap="square"
  />
</template>
